import { render } from "./PlanShell.vue?vue&type=template&id=0ea86b78&scoped=true"
import script from "./PlanShell.vue?vue&type=script&lang=js"
export * from "./PlanShell.vue?vue&type=script&lang=js"

import "./PlanShell.vue?vue&type=style&index=0&id=0ea86b78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea86b78"]])

export default __exports__